import { render, staticRenderFns } from "./PasswordRecoverSuccess.vue?vue&type=template&id=508df3e9"
import script from "./PasswordRecoverSuccess.vue?vue&type=script&lang=js"
export * from "./PasswordRecoverSuccess.vue?vue&type=script&lang=js"
import style0 from "./PasswordRecoverSuccess.vue?vue&type=style&index=0&id=508df3e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports